var NahmSpirit = NahmSpirit || {};

NahmSpirit.GoogleMaps = function () {
	// var _companyLat = jQuery('.map').data('lat');
	// var _companyLong = jQuery('.map').data('long');

	// var _defaults = {
	// 	id: 'Map',
	// 	lat: _companyLat,
	// 	long: _companyLong,
	// 	zoom: 12
	// };



	var _mapStyles = [
		{
			"featureType": "all",
			"elementType": "geometry",
			"stylers": [
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "all",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"saturation": 36
				},
				{
					"color": "#bd9e55"
				},
				{
					"lightness": 40
				},
				{
					"weight": "1.91"
				}
			]
		},
		{
			"featureType": "all",
			"elementType": "labels.text.stroke",
			"stylers": [
				{
					"visibility": "on"
				},
				{
					"color": "#bd9e55"
				},
				{
					"weight": "1.59"
				}
			]
		},
		{
			"featureType": "all",
			"elementType": "labels.icon",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "administrative",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#1b1918"
				},
				{
					"lightness": 20
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "administrative",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"color": "#1b1918"
				},
				{
					"lightness": 17
				},
				{
					"weight": "0.73"
				},
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "landscape",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#1b1918"
				},
				{
					"lightness": 20
				}
			]
		},
		{
			"featureType": "landscape",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#1b1918"
				}
			]
		},
		{
			"featureType": "landscape",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "landscape.man_made",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#1b1918"
				},
				{
					"visibility": "on"
				},
				{
					"saturation": "0"
				},
				{
					"lightness": "0"
				},
				{
					"gamma": "1.00"
				}
			]
		},
		{
			"featureType": "landscape.man_made",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "landscape.natural",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#1b1918"
				},
				{
					"visibility": "on"
				},
				{
					"gamma": "1"
				},
				{
					"lightness": "0"
				},
				{
					"saturation": "0"
				}
			]
		},
		{
			"featureType": "landscape.natural",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "landscape.natural.landcover",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"visibility": "off"
				},
				{
					"color": "#ff0000"
				}
			]
		},
		{
			"featureType": "landscape.natural.landcover",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "landscape.natural.terrain",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"visibility": "on"
				},
				{
					"color": "#1b1918"
				}
			]
		},
		{
			"featureType": "landscape.natural.terrain",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#1b1918"
				},
				{
					"lightness": 21
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#1b1918"
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#bd9e55"
				},
				{
					"lightness": "0"
				},
				{
					"gamma": "1.00"
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"color": "#1b1918"
				},
				{
					"lightness": 29
				},
				{
					"weight": "0.01"
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#bd9e55"
				},
				{
					"lightness": "0"
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#bd9e55"
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "road.local",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#1b1918"
				},
				{
					"lightness": 16
				}
			]
		},
		{
			"featureType": "road.local",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#1b1918"
				}
			]
		},
		{
			"featureType": "road.local",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "transit",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#1b1918"
				},
				{
					"lightness": 19
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#1b1918"
				},
				{
					"lightness": 17
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#1b1918"
				}
			]
		}
	];

	var _settings = {};

	var _init = function (options) {
		// _settings = jQuery.extend({}, _defaults, options || {});
		// // base map
		// var map = new google.maps.Map(document.getElementById(_settings.id), {
		// 	center: {
		// 		lat: _settings.lat,
		// 		lng: _settings.long
		// 	},
		// 	zoom: _settings.zoom,
		// 	mapTypeControlOptions: {
		// 		mapTypeIds: ['styled_map']
		// 	},
		// 	disableDefaultUI: true,
		// 	gestureHandling: 'none',
		// 	zoomControl: false
		// });
		// // custom styles
		// var styledMapType = new google.maps.StyledMapType(_mapStyles, { name: 'Styled Map' });
		// map.mapTypes.set('styled_map', styledMapType);
		// map.setMapTypeId('styled_map');
		// // custom marker
		// var marker = new google.maps.Marker({
		// 	position: new google.maps.LatLng(_settings.lat, _settings.long),
		// 	icon: './img/layout/marker.png',
		// 	animation: google.maps.Animation.BOUNCE,
		// 	map: map
		// });

		// get locations
		let locations = $('#Map').data('locations');
		if (locations) {
			console.log(locations);
			var bound = new google.maps.LatLngBounds();
			// iterate locations
			for (let i = 0; i < locations.length; i++) {
				// add location lat / long to bounding box to find center
  			bound.extend(new google.maps.LatLng(locations[i]['lat'], locations[i]['long']));
			}
			// get map center
			let center = bound.getCenter();
			// initialize base google map
			let map = new google.maps.Map(document.getElementById('Map'), {
				center: center,
				zoom: 9,
				mapTypeControlOptions: {
					mapTypeIds: ['styled_map']
				},
				disableDefaultUI: true,
				gestureHandling: 'none',
				zoomControl: false
			});
			// custom styles
			let styledMapType = new google.maps.StyledMapType(_mapStyles, {name: 'Styled Map'});
			map.mapTypes.set('styled_map', styledMapType);
			map.setMapTypeId('styled_map');
			// add markers
			for (let i = 0; i < locations.length; i++) {
				let marker = new google.maps.Marker({
					position: new google.maps.LatLng(locations[i]['lat'], locations[i]['long']),
					icon: './img/layout/marker.png',
					animation: google.maps.Animation.BOUNCE,
					map: map
				});
			}
		}
	}

	/** PUBLIC API **/
	return {
		init: function (options) { return _init(options); }
	};

}();

// Adding object globally
window.NahmSpirit = NahmSpirit;
